import Payer from './Payer'
import Messaging from './Messaging'
import Indemnities from './Indemnities'
export default { Payer, Messaging, Indemnities }
